import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import { AuditLogFilter } from "../interfaces";

export default {
  getAuditLogs: (payload: AuditLogFilter) => request(METHODS.GET, API.AUDIT_LOG.GET_LIST)({ params: payload }),
  getAuditLogFilters: () => request(METHODS.GET, API.AUDIT_LOG.GET_FILTERS)(),
  getAuditLogById: (id: number) => request(METHODS.GET, API.AUDIT_LOG.GET_DETAIL(String(id)))(),
};
